<section class="landing-page-editor-page">
  <header class="page-header">
    <div>
      <h1>{{ pageTitle }}</h1>
    </div>
    <div class="page-header-actions">
      @if (draft) {
        <div class="landing-page-state">
          <span class="status-chip" [attr.data-state]="draft.publicationState.toLowerCase()">
            {{ draft.publicationState }}
          </span>
          <span class="dirty-state" [class.is-dirty]="hasUnsavedChanges">
            {{ hasUnsavedChanges ? 'Unsaved changes' : 'All changes saved' }}
          </span>
          <span class="updated-state">Updated {{ draft.updatedAt | date: 'short' }}</span>
        </div>
        <button
          type="button"
          class="accent"
          [disabled]="saving || !hasUnsavedChanges"
          (click)="saveCurrentLandingPage()">
          Save landing page
        </button>
      }
      <a class="ghost" routerLink="/landing-pages">Back to landing pages</a>
    </div>
  </header>

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (!sites.length) {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Sites</p>
          <h2>No sites available</h2>
        </div>
        <a class="accent" routerLink="/sites">Manage sites</a>
      </header>
      <p class="empty-state">Create a site before opening the landing page editor.</p>
    </section>
  } @else if (loading) {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Loading</p>
          <h2>Preparing landing page workspace</h2>
        </div>
      </header>
      <p class="empty-state">Loading landing page...</p>
    </section>
  } @else {
    <cms-landing-page-editor
      [landingPage]="landingPage"
      [saving]="saving"
      [canDelete]="!isCreateMode"
      [tagSuggestions]="tagSuggestions"
      [availableImages]="availableImages"
      [availableGalleries]="availableGalleries"
      (deleteRequested)="deleteLandingPage($event)" />
  }
</section>
